// globalVariable.js

const globalVariable = {
	showPdf: false, //pdf预览显隐
	pdfUrl: '' //pdf路径
};

export default globalVariable;